export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details: unknown,
  ) {
    super(message)
  }
}

async function request<T>(method: string, url: string, body?: unknown, raw?: { contentType: string; text: string }): Promise<T> {
  const init: RequestInit = {
    method,
    credentials: 'same-origin',
    headers: raw ? { 'content-type': raw.contentType } : body !== undefined ? { 'content-type': 'application/json' } : {},
  }
  if (raw) init.body = raw.text
  else if (body !== undefined) init.body = JSON.stringify(body)
  const res = await fetch(url, init)
  const text = await res.text()
  let data: unknown = null
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    data = text
  }
  if (!res.ok) {
    const e = (data ?? {}) as { error?: string; message?: string; details?: unknown }
    throw new ApiError(res.status, e.error ?? 'error', e.message ?? res.statusText, e.details ?? null)
  }
  return data as T
}

export const api = {
  get: <T>(url: string) => request<T>('GET', url),
  post: <T>(url: string, body?: unknown) => request<T>('POST', url, body),
  patch: <T>(url: string, body?: unknown) => request<T>('PATCH', url, body),
  put: <T>(url: string, body?: unknown) => request<T>('PUT', url, body),
  del: <T>(url: string) => request<T>('DELETE', url),
  postText: <T>(url: string, text: string, contentType = 'text/csv') => request<T>('POST', url, undefined, { contentType, text }),
}

export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) return e.message
  if (e instanceof Error) return e.message
  return String(e)
}
